import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import PropTypes from 'prop-types';
import DeliveryAddress from '../../UserManagementPage/DeliveryAddress';
import OrderItemList from './OrderItemList';
import RowItem from './RowItem';
import { Box, Flex, Text } from 'core/ui/atoms';
import { WeekContainer } from 'onramp/ui/components';

const WeekOrderSummary = ({ orderData, deliveryDays, onDeleteSwapRequest, refetchOrders, refetchBillingSummary }) => {
  const getWeekStartDate = (dayId) => {
    const deliveryDay = deliveryDays.find((day) => day.id === dayId);
    return deliveryDay ? moment(deliveryDay.date).format('MMMM Do') : '';
  };

  const calculateSubtotals = (orderItem) => {
    const addonSubtotal = orderItem.addons.reduce((sum, addon) =>
      sum + (addon.price.amount * addon.quantity), 0);

    const swapSubtotal = orderItem.swaps.reduce((sum, swap) =>
      sum + (swap.price.amount * swap.quantity), 0);

    return {
      totalSubtotal: {
        amount: addonSubtotal + swapSubtotal,
        __typename: 'Money',
      },
    };
  };

  return (
    <Container direction='column' alignItems='normal'>
      {orderData.map((orderItem) => (
        <OrderContainer key={orderItem.dayId}>
          <WeekContainerStyle>
            <WeekContainer>
              Week of
              <WeekDateText>{getWeekStartDate(orderItem.dayId)}</WeekDateText>
            </WeekContainer>
          </WeekContainerStyle>
          <FlexRowSpaced direction='column'>
            <OrderItemList
              items={orderItem.swaps}
              onDeleteItem={onDeleteSwapRequest}
              refetchOrders={refetchOrders}
              refetchBillingSummary={refetchBillingSummary}
              type='swap'
            />
            <OrderItemList
              items={orderItem.addons}
              onDeleteItem={onDeleteSwapRequest}
              refetchOrders={refetchOrders}
              refetchBillingSummary={refetchBillingSummary}
              type='addon'
            />
            <RowItem
              title='Sub Total'
              value={calculateSubtotals(orderItem).totalSubtotal}
            />
            <DeliveryAddress title="This Week's Delivery Address" type='small' />
          </FlexRowSpaced>
        </OrderContainer>
      ))}
    </Container>
  );
};

WeekOrderSummary.propTypes = {
  orderData: PropTypes.array.isRequired,
  deliveryDays: PropTypes.array.isRequired,
  onDeleteSwapRequest: PropTypes.func.isRequired,
  refetchOrders: PropTypes.func.isRequired,
  refetchBillingSummary: PropTypes.func.isRequired,
};

const WeekContainerStyle = styled(Box)`
  width: 40%;
  height: unset;
  ${(p) => p.theme.max('md')`
    width: unset;
  `}
`;

const OrderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  column-gap: 40px;
  ${(p) => p.theme.max('md')`
    display: block;
    width: 100%;
    column-gap: normal;
  `}
`;

const WeekDateText = styled(Text)`
  color: ${(p) => p.theme.colors.creamWhite};
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 18px;
  font-style: italic;
  font-weight: 800;
  line-height: 32px;
  letter-spacing: 0.54px;
  margin: 0px;
`;

const Container = styled(Flex)`
  row-gap: 10px;
  margin-top: 24px;
`;

const FlexRowSpaced = styled(Flex)`
  row-gap: 16px;
  margin-top: 0px;
  ${(p) => p.theme.max('md')`
    margin-top: 24px;
  `}
`;

export default WeekOrderSummary;
